export const defaultColors = ["#851dd6", "#62d3ca", "#FC7482", "#54cdf0", "#ef485f","#5858ef", "#333333", "#fa8c46"]

export const defaultDropShadow = {
    enabled: true,
    color: '#000',
    top: 18,
    left: 7,
    blur: 10,
    opacity: 0.2
}
export const defaultStroke = {
  show: true,
  curve: 'straight',
  lineCap: 'butt',
  colors: defaultColors,
  width: 3,
  dashArray: 0, 
}

export const ActivityDonutOptions  = {
    options:{
      labels: ["activity","standby","inactive","lock"],
      stroke: { width: 0 },
      title: {
        text: 'Device Status',
        align: 'left'
      },
      fill:{
        colors: defaultColors,
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        width: "100%",
        height: 110,
        markers: {
          fillColors: defaultColors,
        },
        formatter: function (seriesName, opts) {
          return [
            seriesName,
            " : ",
            opts.w.globals.series[opts.seriesIndex],
          ];
        },
      },
      plotOptions: {
        pie:{
          expandOnClick: true,
          donut: {
            labels: {
              show:true,
              name:{
                show:false
              },
              value:{
                show:true
              },
              total: {
                show: true,
                showAlways:true,
                formatter: function (w) {
                  return 822
                },
              },
            },
          },
        }
      },
    },
    series:[643,128,99,48]
}

export const CustomCidDonutOptions = {
   options:{
     labels: ["DEVOS-TAPBUS-01","DEVOS-TAPBUS-02","DEVOS-TAPBUS-03","DEVOS-TAPBUS-04","DEVOS-TAPBUS-05"],
     stroke: { width: 0 },
     title: {
       text: 'Device Owners',
       align: 'left'
     },
     fill:{
       colors: defaultColors,
     },
     legend: {
       show: true,
       position: "bottom",
       horizontalAlign: "center",
       width: "100%",
       height: 110,
       markers: {
         fillColors:defaultColors,
       },
       formatter: function (seriesName, opts) {
         return [
           seriesName,
           " : ",
           opts.w.globals.series[opts.seriesIndex],
         ];
       },
     },
     plotOptions: {
       pie:{
         expandOnClick: true,
         donut: {
           labels: {
             show:true,
             name:{
               show:true
             },
             value:{
               show:true
             },
             total: {
               show: true,
               showAlways:true,
               formatter: function (w) {
                 return 2657
               },
             },
           },
         },
       }
     },
   },
   series:[137,263,176,224,200]
   
}

export  const AccountDonutOptions = {
    options:{
      labels: ["Lock","Unlock","Login","Export Data"],
      stroke: { width: 0 },
      fill:{
        colors: defaultColors,
      },
      title: {
        text: 'Account Activity (7 days)',
        align: 'left'
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        width: "100%",
        height: 110,
        markers: {
          fillColors: defaultColors,
        },
        formatter: function (seriesName, opts) {
          return [
            seriesName,
            " :    ",
            opts.w.globals.series[opts.seriesIndex],
          ];
        },
      },
      plotOptions: {
        pie:{
          expandOnClick: true,
          donut: {
            labels: {
              show:true,
              name:{
                show:true
              },
              value:{
                show:true
              },
              total: {
                show: true,
                showAlways:true,
                formatter: function (w) {
                  return 224
                },
              },
            },
          },
        }
      },
    },
    series:[34,178,6,34]
    
}

export const NfcMultiOptions = {
    options:{
      title: {
        text: 'NFC Operations (24 hours)',
        align: 'left'
      },
      colors: defaultColors,
      xaxis: {
        categories:["DEVOS-TAPBUS-01","DEVOS-TAPBUS-02","DEVOS-TAPBUS-03","DEVOS-TAPBUS-04"]
        //  categories: ["8/1","8/2","8/3","8/4","8/5","8/6","8/7","8/8", "8/9", "8/10", "8/11", "8/12", "8/13", "8/14", "8/15","8/16","8/17","8/18","8/19","8/20","8/21","8/22","8/23","8/24","8/25","8/26","8/27","8/28","8/29","8/30","8/31"]
      },
    },
    series:[
        {
      
          name: "Read",
          data: [128, 129, 393,136]
        },
        {
          name: "Write",
          data: [12, 11, 104, 18]
        },
        {
          name: "Error",
          data: [48,22,15,17]
        },

    ]
}
export const NfcLineOptions = {
  series:[
    {
    
        name: "Read",
        data: [1288, 1829, 1833,1836,786, 1382, 1832, 1383,1843,1834,1834,845,1586,1878,1586,1585,1899,812,814,1284,1866,1877,1586,1558,1998,1824,2458,2388,2599,1987,2245]
      },
      {
        name: "Write",
        data: [192, 191, 194, 198,93, 179, 193, 139,194,39, 189, 197, 139, 193,149,93, 198, 197, 193, 139,149,95 ,29,198, 197,199,219,329,194,208,223]
      },
      {
        name: "Error Read",
        data: [87,227,175,177,67,176,417,337,577,474,171,327,172,173,557,577,712,712,172,174,372,172, 117, 174, 187, 177, 173, 203,278,206,274]
      },
      {
        name: "Error Write",
        data: [27,127,155,107,67,106,217,137,177,174,271,127,72,103,357,177,212,112,72,174,372,192, 197, 104, 17, 77, 173, 23,28,26,74]
      },

  ],
  options:{
    chart: {
      dropShadow: defaultDropShadow,
    },
    stroke: defaultStroke,
    title: {
      text: 'Total',
       align: 'left'
    },
    colors: defaultColors,
    xaxis: {
        tickPlacement: 'between',
        categories: ["8/1","8/2","8/3","8/4","8/5","8/6","8/7","8/8", "8/9", "8/10", "8/11", "8/12", "8/13", "8/14", "8/15","8/16","8/17","8/18","8/19","8/20","8/21","8/22","8/23","8/24","8/25","8/26","8/27","8/28","8/29","8/30","8/31"]
    },
    
  }
}

export const DeviceLineOptions = {
    options: {
        chart:{
            dropShadow: defaultDropShadow
        },
        title:{
          text:"Device Activity Overview",
          align:"left"
        },
        colors: defaultColors ,
        xaxis: {
          tickPlacement:"between",
          categories: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
        },
        
    },
    series: [
        {
          name: "Offline",
          data: [30, 40, 145, 50, 149,160, 170, 191,135,144,86,23]
        },
        {
          name: "Online",
          data: [230, 240, 145, 250, 149,360, 370, 291,335,244,286,323]
        }
      ],

}

export const DailyActivationOptions = {
  options: {
    title: {
      text: 'Daily New Activitions',
      align: 'left'
    },
    stroke: defaultStroke,
    xaxis: {
      tickPlacement: 'between',
      categories: ["8/7","8/8", "8/9", "8/10", "8/11", "8/12", "8/13", "8/14", "8/15","8/16","8/17","8/18","8/19","8/20","8/21","8/22","8/23","8/24","8/25","8/26","8/27","8/28"]
    },
  },
  series: [
    {
      name: "Activation",
      data: [69,130, 240, 145, 150, 129, 160, 170, 191,134,235,134,189,145,134,178,123,23,35,32,21,22,20,11,0,0,0,0,0,0,0,0,0,0]
    }
  ],
}

export const TotalActivationOptions = {
  options: {
    title: {
      text: 'Total',
      align: 'left'
    },
    stroke: defaultStroke,
    xaxis: {
      tickPlacement: 'between',
      categories: ["8/7","8/8", "8/9", "8/10", "8/11", "8/12", "8/13", "8/14", "8/15","8/16","8/17","8/18","8/19","8/20","8/21","8/22","8/23","8/24","8/25","8/26","8/27","8/28"]
    }
  },
  series: [
    {
      name: "Total",
      data: [1000,1130, 1240, 1345, 1450, 1529, 1620, 1708, 1810,2134,2135,2234,2289,2345,2356,2390,2399,2412,2435,2439,2442,2442,2460,2489]
    }
  ]
}

export const DailyActivityOptions = {
  options:{
    chart: {
        type: 'line',
        dropShadow: defaultDropShadow,
    },
    stroke:defaultStroke,
    colors: defaultColors,
    xaxis: {
        categories: ["8/7","8/8", "8/9", "8/10", "8/11", "8/12", "8/13", "8/14", "8/15","8/16","8/17","8/18","8/19","8/20","8/21","8/22","8/23","8/24","8/25","8/26","8/27","8/28"]
    },
    
  },
  series:[
      {
        name: "Activity",
        data: [128, 129, 133,136, 132, 132, 133,143,134,134,156,178,156,155,199,124,166,177,156,155,199,124,245,238]
      },
      {
        name: "Inactivity",
        data: [12, 11, 14, 18, 17, 13, 13,14, 18, 17, 13, 13,14, 18, 17, 13, 13,14, 18, 17,19,21,32,14]
      },
      {
        name: "Standby",
        data: [12, 11, 14, 18, 17, 13, 13,8,22,15,17,16,41,33,57,44,32,12,13,12,12,12,14,32]
      },
      {
        name: "Lock",
        data: [12, 11, 14, 18, 17, 13, 13, 13,8,22,15,17,16,41,33,57,44,32,12,13,12,2,8,1]
      }
],
}

export const BatteryMulOptions = {
  options:{
    chart: {
      dropShadow: defaultDropShadow,
    },
    stroke: defaultStroke,
    title: {
      text: 'Total',
       align: 'left'
    },
    colors: defaultColors,
    xaxis: {
        tickPlacement: 'between',
        categories:[]
    },
    
  },
  series:[]
}


